import React, { useState, useRef, useEffect, useCallback } from "react";
import {
    Input,
    Table,
    Button,
    message,
    Form,
    Popconfirm,
    Modal,
    Card,
    Tooltip,
} from "antd";
import {
    EditOutlined,
    SaveTwoTone,
    CloseCircleTwoTone,
    PlusOutlined,
} from "@ant-design/icons";
import { AiOutlineDelete } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { showAuthLoader, hideAuthLoader } from "../../appRedux/actions/Auth";
import Service from "../../service";

const Skills = () => {
    const [IsModalView2, setIsModalView2] = useState(false);
    const [skillsList, setSkillsList] = useState([]);
    let [flag, setFlag] = useState(false);
    const [edtitext, setEdittext] = useState({});
    let [editid, setEditid] = useState();

    const [searchText, setSearchText] = useState("");
    const [seachEnabled, setSearchEnabled] = useState(false);

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 25,
        total: 0,
    });

    const Search = Input.Search;

    const searchRef = useRef();


    const [form] = Form.useForm();
    const dispatch = useDispatch();

    const openEventModalView2 = () => {
        setIsModalView2(true);
    };

    const closeEventModalView2 = () => {
        form.resetFields();
        setIsModalView2(!IsModalView2);
    };

    const resetFields = () => {
        form.resetFields();
    };

    useEffect(() => {
        getSkillsList();
    }, [pagination.current, pagination.pageSize, searchText]);

    const handleSubmit = async (values) => {
        try {
            dispatch(showAuthLoader());
            const reqBody = {
                skill_name: values.skill,
            };
            const response = await Service.makeAPICall({
                methodName: Service.postMethod,
                api_url: Service.addSkill,
                body: reqBody,
            });
            if (response.data.status === 200) {
                message.success(response.data.message);
                setIsModalView2(false);
                form.resetFields();
                getSkillsList();
            } else {
                message.error(response.data.message);
            }
            dispatch(hideAuthLoader());
        } catch (error) {
            dispatch(hideAuthLoader());
            message.error("Failed to add skill");
            console.error(error);
        }
    };

    const onSearch = (value) => {
        setSearchText(value);

        setPagination({ ...pagination, current: 1 });
    };
    const resetSearchFilter = (e) => {
        const keyCode = e && e.keyCode ? e.keyCode : e;
        switch (keyCode) {
            case 8:
                if (searchRef.current.state?.value?.length <= 1 && seachEnabled) {
                    searchRef.current.state.value = "";
                    setSearchText("");
                    setSearchEnabled(false);
                }
                break;
            case 46:
                if (searchRef.current.state?.value?.length <= 1 && seachEnabled) {
                    searchRef.current.state.value = "";
                    setSearchText("");
                    setSearchEnabled(false);
                }
                break;
            default:
                break;
        }
    };

    const handlechange = (e) => {
        console.log(e.target.value, "handle change value");
        let designation = e.target.value;
        setEdittext({ ...edtitext, designation: designation });
    };

    const handleEdit = async (id) => {
        let name = edtitext?.designation.trim();
        try {
            dispatch(showAuthLoader());
            const reqBody = {
                skill_name: name,
            };
            const response = await Service.makeAPICall({
                methodName: Service.putMethod,
                api_url: Service.updateSkill + "/" + id,
                body: reqBody,
            });
            if (response.data.status === 200) {
                message.success(response.data.message);
                getSkillsList();
                setEdittext({});
            } else {
                message.error(response.data.message);
            }
            dispatch(hideAuthLoader());
        } catch (error) {
            dispatch(hideAuthLoader());
            message.error("Failed to update skill");
            console.error(error);
        }
    };

    const deleteSkill = async (id) => {
        try {
            dispatch(showAuthLoader());
            const response = await Service.makeAPICall({
                methodName: Service.putMethod,
                api_url: Service.deleteSkill + "/" + id,
            });
            if (response.data.status === 200) {
                getSkillsList();
                message.success(response.data.message);
            } else {
                message.error(response.data.message);
            }
            dispatch(hideAuthLoader());
        } catch (error) {
            dispatch(hideAuthLoader());
            message.error("Failed to delete skill");
            console.error(error);
        }
    };

    const columns = [
        {
            title: "Skills",
            dataIndex: "skill_name",
            key: "skills",
            render: (text, record, index) => {
                return editid === record?._id ? (
                    <Input
                        defaultValue={ record.skill_name }
                        onChange={ handlechange }
                    />
                ) : (
                    <span style={ { textTransform: "capitalize" } }>{ record.skill_name }</span>
                );
            },
        },
        {
            title: "Actions",
            dataIndex: "action",
            render: (text, record, index) => (
                <div
                    style={ {
                        display: "flex",
                        flexwrap: "wrap",
                    } }
                >
                    { flag == true && editid == record?._id ? (
                        <>
                            <Tooltip title="Save">
                                <Button type="link edit">
                                    <SaveTwoTone
                                        style={ { fontSize: "18px" } }
                                        onClick={ () => {
                                            handleEdit(record?._id);
                                            setFlag(false);
                                            setEditid("");
                                        } }
                                    />
                                </Button>
                            </Tooltip>
                            <Tooltip title="Cancel">
                                <Button
                                    type="link delete"
                                    title="View"
                                    onClick={ () => setEditid("") }
                                >
                                    <CloseCircleTwoTone style={ { fontSize: "18px" } } />
                                </Button>
                            </Tooltip>
                        </>
                    ) : (
                        <>
                            <Tooltip title="Edit">
                                <Button type="link edit">
                                    <EditOutlined
                                        style={ { fontSize: "18px" } }
                                        onClick={ () => {
                                            // handleEdit(record?._id);
                                            setEditid(record._id);
                                            setFlag(true);
                                        } }
                                    />
                                </Button>
                            </Tooltip>
                            <Popconfirm
                                title="Are you really want to delete this skill?"
                                okText="Yes"
                                cancelText="No"
                                onConfirm={ () => deleteSkill(record._id) }
                            >
                                <Tooltip title="Delete">
                                    <Button type="link delete">
                                        <AiOutlineDelete style={ { fontSize: "18px" } } />
                                    </Button>
                                </Tooltip>
                            </Popconfirm>
                        </>
                    ) }
                </div>
            ),
        },

    ];

    const getSkillsList = useCallback(async () => {
        try {
            dispatch(showAuthLoader());

            // Serialize params manually
            const body = {
                skill_name: searchText,
                pageNum: pagination.current,
                pageLimit: pagination.pageSize,
            };

            const response = await Service.makeAPICall({
                methodName: Service.postMethod,
                api_url: Service.getSkills,
                body: body,
            });

            if (response.data.status === 200) {
                const skills = response.data.data.map((item) => ({
                    ...item,
                    skill_name: item.skill_name,
                }));
                setSkillsList(skills);
                const totalCount = response?.data?.metadata?.totalFilteredCount ||
                    response?.data?.metadata?.totalCount ||
                    response?.data?.total ||
                    skills.length;
                setPagination((prev) => ({
                    ...prev,
                    total: totalCount,
                }));
            } else {
                setSkillsList([]);
                setPagination((prev) => ({
                    ...prev,
                    total: 0, // Reset total when no data
                }));
                message.error(response.data.message);
            }
            dispatch(hideAuthLoader());
        } catch (error) {
            dispatch(hideAuthLoader());
            setSkillsList([]);
            setPagination((prev) => ({
                ...prev,
                total: 0, // Reset total when no data
            }));
            message.error("Failed to fetch skills");
            console.error(error);
        }
    }, [searchText, pagination.current, pagination.pageSize]);

    const handleTableChange = (paginationObj, filters, sorter) => {
        setPagination({
            ...pagination,
            current: paginationObj.current,
            pageSize: paginationObj.pageSize,
        });
    };

    const getFooterDetails = () => {
        return (
            <label>
                Total Records Count is { pagination.total > 0 ? pagination.total : 0 }
            </label>
        );
    };

    return (
        <>
            <Card className="employee-card" >

                <div className=" inout-header text-left">
                    <h2> Skills </h2>
                    <div className="header-btns">
                        <Button
                            // disabled
                            type="primary"
                            className="addleave-btn"
                            icon={ <PlusOutlined /> }
                            onClick={ () => openEventModalView2() }
                        >
                            Add
                        </Button>
                    </div>
                </div>
                <Card className="main-content-wrapper" >

                    <div className="search-wrapper">

                        <Search
                            ref={ searchRef }
                            placeholder="Search..."
                            onSearch={ onSearch }
                            onKeyUp={ resetSearchFilter }
                            style={ { width: 200 } }
                            className="mr2"
                        />


                    </div>

                    <div className="main-table-wrapper">

                        <Table
                            columns={ columns }
                            pagination={ {
                                showSizeChanger: true,
                                ...pagination,
                            } }
                            footer={ getFooterDetails }
                            onChange={ handleTableChange }
                            dataSource={ skillsList }
                        />
                    </div>
                </Card>

            </Card>

            <Modal
                title="Add Skills"
                width={ 600 }
                visible={ IsModalView2 }
                onCancel={ closeEventModalView2 }
                footer={ [
                    <Button key="cancel" className="delete-btn" onClick={ closeEventModalView2 }>
                        Cancel
                    </Button>,
                    <Button key="clear" className="delete-btn" onClick={ resetFields }>
                        Reset
                    </Button>,
                    <Button key="submit" type="primary" id="savebutton" htmlType="submit" onClick={ () => form.submit() }>
                        Save
                    </Button>,
                ] }
            >
                <Form form={ form } layout="vertical" onFinish={ handleSubmit }>
                    <div className="main-form-wrapper">
                        <div className="form-container">
                            <div className="form-row">
                                <div className="form-col">
                                    <div className="form-item">
                                        <Form.Item
                                            label="Skill"
                                            name="skill"
                                            rules={ [{ required: true, message: "Please select Skill" }] }
                                        >
                                            <Input />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className="form-col">
                                    {/* Empty column for spacing */ }
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </Modal>
        </>
    );
};

export default Skills;
